import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Re-export TranslateModule for lazy page modules.
 * Root config (forRoot + loader) stays in AppModule.
 */
@NgModule({
  exports: [TranslateModule],
})
export class SharedTranslateModule {}



// WEBPACK FOOTER //
// ./src/app/shared-translate.module.ts